/**
 * レシピ用S3のオブジェクトキーを組み立てる関数を集約する。
 * S3のPut/DeleteとImageFluxのpathで同じキー規則を参照するため、ここで一元管理する。
 */

/**
 * 投稿者プロフィール画像のS3オブジェクトキーを組み立てる。
 * キー規則: uploads/author/profile_image/{authorId}/{filename}
 */
export function createAuthorProfileImageKey(
  authorId: number,
  filename: string,
): string {
  return `uploads/author/profile_image/${authorId}/${filename}`;
}

/**
 * レシピカテゴリアイコン画像のS3オブジェクトキーを組み立てる。
 * キー規則: uploads/recipe_category/icon_image/{categoryId}/{filename}
 */
export function createRecipeCategoryIconImageKey(
  categoryId: number,
  filename: string,
): string {
  return `uploads/recipe_category/icon_image/${categoryId}/${filename}`;
}

/**
 * 献立メイン画像のS3オブジェクトキーを組み立てる。
 * キー規則: uploads/menu/main_image/{menuId}/{filename}
 */
export function createMenuMainImageKey(
  menuId: number,
  filename: string,
): string {
  return `uploads/menu/main_image/${menuId}/${filename}`;
}

/**
 * レシピメイン画像のS3オブジェクトキーを組み立てる。
 * キー規則: uploads/recipe/main_image/{recipeId}/{filename}
 */
export function createRecipeMainImageKey(
  recipeId: number,
  filename: string,
): string {
  return `uploads/recipe/main_image/${recipeId}/${filename}`;
}

/**
 * レシピ候補画像のS3オブジェクトキーを組み立てる。
 * キー規則: uploads/recipe_candidate_image/candidate_image/{candidateImageId}/{filename}
 */
export function createRecipeCandidateImageKey(
  candidateImageId: number,
  filename: string,
): string {
  return `uploads/recipe_candidate_image/candidate_image/${candidateImageId}/${filename}`;
}
